import { render, staticRenderFns } from "./confirmation-screen-step.vue?vue&type=template&id=6a912bd6&scoped=true"
import script from "./confirmation-screen-step.vue?vue&type=script&lang=ts"
export * from "./confirmation-screen-step.vue?vue&type=script&lang=ts"
import style0 from "./confirmation-screen-step.vue?vue&type=style&index=0&id=6a912bd6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a912bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a912bd6')) {
      api.createRecord('6a912bd6', component.options)
    } else {
      api.reload('6a912bd6', component.options)
    }
    module.hot.accept("./confirmation-screen-step.vue?vue&type=template&id=6a912bd6&scoped=true", function () {
      api.rerender('6a912bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/steps/confirmation-screen-step.vue"
export default component.exports